var country = document.getElementById("account_country");
var country_placeholder = document.createElement("option");
country_placeholder.text = "Select a Country";

function handleCountryChange() {
  if (!country) return;

  $.ajax({
    url: "/states?country=" + country.value,
    type: "GET",
    success: checkForDataAttr
  });

  checkForMessage();
}

$(document).ready(function () {
  if (country && country.value && country.value !== "US") {
    handleCountryChange();
  }
});

if (country) {
  country.addEventListener("change", handleCountryChange);
}

function checkForMessage() {
  if (
    !window.closed &&
    !window.location.href.includes("/add_card") &&
    !window.location.href.includes("/one_time_charge")
  ) {
    let message = document.querySelector(".ph-message");
    if (!message && country.value != "US") {
      country.insertAdjacentHTML(
        "afterend",
        "<p class='ph-message'> Please make sure to add country code to phone number. </p>"
      );
    } else if (message && country.value == "US") {
      message.remove();
    }
  }
}

function checkForDataAttr() {
  let state = document.getElementById("account_state");
  let attr = state.getAttribute("data_attr");

  if (state && attr) {
    for (let i = 0; i < state.options.length; i++) {
      if (state.options[i].value == attr) {
        state.selectedIndex = i;
        break;
      }
    }
  }
}

window.handleCountryChange = handleCountryChange;